export const selectTypeSx = {
  '.MuiSelect-select.MuiSelect-select': {
    paddingLeft: '25px',
  },
};
